import React, { useEffect } from "react";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import {
    IconButton,
    Popover,
    makeStyles,
    TextField,
    Typography,
    Button
} from "@material-ui/core";

let Editor = null;

//import react-draft-wysiwyg css 
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import {
    FormatBold as FormatBoldIcon,
    FormatItalic as FormatItalicIcon,
    Code as CodeIcon,
    FormatUnderlined,
    FormatStrikethrough,
    FormatListBulleted,
    FormatListNumbered
} from "@material-ui/icons";
import { Controller } from "react-hook-form";

const styleMap = {
    'STRIKETHROUGH': {
        textDecoration: 'line-through',
    },
};

function customBlockStyles(contentBlock) {
    const type = contentBlock.getType();
    if (type === 'unstyled') {
      return '!my-0';
    }
  }

const DraftJS = ({ state, onChange }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [editorState, setEditorState] = React.useState(null);

    useEffect(() => {
        Editor = require('react-draft-wysiwyg').Editor;
        try {
            setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(state))));
        } catch (e) { setEditorState(EditorState.createEmpty()); }
    }, [])


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    // return null;

    if (!Editor) return null

    return (
        <Editor
            editorState={editorState}
            wrapperClassName="bg-transparent"
            editorClassName="text-base ring-1 ring-gray-button p-4 rounded-sm min-h-[200px]"
            blockStyleFn={customBlockStyles}
            onEditorStateChange={(e) => {
                setEditorState(e);
                onChange(JSON.stringify(convertToRaw(e?.getCurrentContent())))
            }
            }
            toolbar={{
                options: ['inline', 'list', 'link'],
                inline: {
                    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
                },
                bold: { className: 'bordered-option-classname' },
                italic: { className: 'bordered-option-classname' },
                underline: { className: 'bordered-option-classname' },
                strikethrough: { className: 'bordered-option-classname' },
                code: { className: 'bordered-option-classname' },
            }}
            stripPastedStyles
            spellCheck
        />
    );
}

export default function RTE({ control, name, defaultValue }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ value, onChange }) => {
                return <DraftJS state={value} onChange={onChange} />;
            }}
        />
    )
}

